/* tslint:disable */
/* eslint-disable */
/**
 * radia.cz
 * Seznam endpointu
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FrontWebStreamModel
 */
export interface FrontWebStreamModel {
    /**
     * Url stream
     * @type {string}
     * @memberof FrontWebStreamModel
     */
    url?: string;
    /**
     * Type
     * @type {string}
     * @memberof FrontWebStreamModel
     */
    type?: string;
}

/**
 * Check if a given object implements the FrontWebStreamModel interface.
 */
export function instanceOfFrontWebStreamModel(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FrontWebStreamModelFromJSON(json: any): FrontWebStreamModel {
    return FrontWebStreamModelFromJSONTyped(json, false);
}

export function FrontWebStreamModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): FrontWebStreamModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'url': !exists(json, 'url') ? undefined : json['url'],
        'type': !exists(json, 'type') ? undefined : json['type'],
    };
}

export function FrontWebStreamModelToJSON(value?: FrontWebStreamModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'url': value.url,
        'type': value.type,
    };
}

